export default __webpack_public_path__ + "static/maitake-ddc13d9123bba849efe939343a0f252d.webp";